import { useCallback, useState } from 'react';
import {
  readWorkspaceDashboardSectionState,
  type WorkspaceDashboardSectionId,
  type WorkspaceDashboardSectionState,
  writeWorkspaceDashboardSectionState,
} from './workspaceDashboardSectionStorage';

export const useWorkspaceDashboardSections = () => {
  const [sections, setSections] = useState(readWorkspaceDashboardSectionState);

  const setSectionExpanded = useCallback(
    (sectionId: WorkspaceDashboardSectionId, expanded: boolean) => {
      setSections((prev) => {
        const next = { ...prev, [sectionId]: expanded };
        writeWorkspaceDashboardSectionState(next);
        return next;
      });
    },
    [],
  );

  return { sections, setSectionExpanded };
};
